import React, { useState, useEffect, Fragment } from "react";
import { Col, Container, Row, Form, Table, Image } from "react-bootstrap";
import LeftSideNavigation from "../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import PropTypes from "prop-types";
import {
  get_subscription_details,
  admin_payout_vendor,
  get_merchant_statement,
} from "../../../store/actions/SuperAdminActions/superAdminManageTransactions";
import Dialog from "@material-ui/core/Dialog";

import DialogContent from "@material-ui/core/DialogContent";
import { useHistory } from "react-router";
import {
  DialogTitle,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  Menu,
  MenuItem,
} from "@material-ui/core";
import { connect, useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { AmealioLoader } from "../../Loader/AmealioLoader";
import Alert from "react-s-alert";
import axios from "axios";
import { NEFT, serverApi } from "../../../config/Keys";
import {
  CLEAR_LOADER,
  SET_LOADER,
  SINGLE_VENDOR_SETTLEMENT,
} from "../../../store/types";
import isEmpty from "../../../store/validation/is-Empty";
import InfoToolTip from "../../reusableComponents/InfoTooltipComponent";
import HomeReusableTopBarNavigation from "../../superAdminComponents/superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import CSVDownloader from "../../reusableComponents/csvDownload/csvDownload";
import SelectFilter from "../../reusableComponents/selectFilter";

const MerchantStatement = (props) => {
  const [state, setState] = useState(0);

  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(
    moment().subtract(30, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [dateQuery, setDateQuery] = useState({});


  const [showFilter, setShowFilter] = useState(false);

  const [filter, setFilter] = useState({
    location: "",
    search: false,
  });

  // const [filteredData, setFilteredData] = useState({});

  const statement = useSelector(state => state.superadminManageTransactions.single_vendor_statement);
  const userFilter = [
    { title: "Total Amount", disabled: true },
    { title: `Low to High 🠑`, disabled: false },
    { title: "High to Low 🠓", disabled: false },
  ];

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [sort, setSort] = useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [type, setType] = useState(0)

  const onTypeChange = (type) => {
    setType(type);
  }

  const totalComission = (orders, comissionCode) => {
    let orderTotal = orders?.reduce((a, b) => parseFloat(a) + parseFloat(b?.offerSettlement === 'ADMIN' ? b.base_amount : (b.base_amount - b.discount?.amount)), 0) || 0;
    let percent = parseFloat(comissionCode?.description || 0);
    let comission = (orderTotal * percent) / 100;
    let gst = (comission * 18) / 100
    return comission + gst
  }


  const onDateChangeHandler = () => (data) => {
    setDateQuery(data);
  };

  const searchData = (data) => {
    let returnData = [];
    if (search) {
      if (state === 0) {
        returnData = data?.orders?.filter((item) => {
          return (
            (item && item.order_id.includes(search))
          );
        });
      }
      data.orders = returnData;
    }
    return data;
  }
  let filteredData = { ...statement };

  filteredData = searchData(statement);

  // useEffect(() => {
  //   setFilteredData(statement);
  // }, [statement])

  // useEffect(() => {
  //   setFilteredData(searchData(filteredData))
  // }, [search])


  const downloadData = {
    headers: [
      { label: "Restaurant Name", key: "name" },
      { label: "ID", key: "id" },
      { label: "Tip Amount", key: "tip" },
      { label: "Order Amount", key: "order" },
      { label: "Event Amount", key: "event" },
      { label: "Scan Amount", key: "scan" },
      { label: "Total Amount", key: "total" },
    ],
    data: filteredData?.orders
      ? filteredData?.orders?.map(() => {
        return {
          // name: ele?.restaurant_name,
          // id: ele?._id,
          // tip: ele?.totalTip.toFixed(2),
          // order: ele?.totalOrder.toFixed(2),
          // event: ele?.totalEvent.toFixed(2),
          // scan: ele?.totalScan.toFixed(2),
          // total: (
          //   ele?.totalTip +
          //   ele?.totalOrder +
          //   ele?.totalEvent +
          //   ele?.totalScan
          // ).toFixed(2),
        };
      })
      : [],
  };

  const onSuccess = () => {
    setLoading(false);
  };

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      setLoading(true);
      const token = props.auth.user.accessToken;
      props.get_merchant_statement(
        token,
        props?.vendorAccess?.vendor_id || props?.auth.user?.VendorUser?._id,
        dateQuery.startDate || '2021-10-20',
        dateQuery.endDate || '2021-11-02',
        onSuccess
      );
    }
  }, [dateQuery]);

  if (type === 1) {
    let orders = filteredData?.orders.filter(ele => ele.settleOrderAmount);
    filteredData.orders = orders
  } else if (type === 2) {
    let orders = filteredData?.orders.filter(ele => !ele.settleOrderAmount);
    filteredData.orders = orders
  } else if (type === 3) {
    let orders = filteredData?.orders.filter(ele => !ele.settleOrderAmount);
    filteredData.orders = orders
  } else if (type === 4) {
    let orders = filteredData?.orders.filter(ele => ele.blockSettlement);
    filteredData.orders = orders
  }

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={0} />
          </div>
          <div className="super-admin-right-side-panel">
            <Container fluid>
              <div className="d-flex justify-content-between align-items-center">
                <div className="super_admin_add_vendor mb-1">
                  <h5 className="main_header_text">Account Statement</h5>
                </div>
              </div>
              <hr />
              {/* <div className="f12-500">
                      Report Range Date  {moment(statement?.startDate).format('ll')} - {moment(statement?.endDate).format('ll')}
                    </div> */}
              <Row className="align-items-center">
                <Col md={7}>
                  <div className="row super-admin-toptext-searchbar-icon">
                    <div className="col-6">
                      <div className="col-12 p-0">
                        <Form.Control
                          type="text"
                          placeholder="Search"
                          onChange={(e) => setSearch(e.target.value)}
                          value={search}
                          className="amSearch w-100"
                        />
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={3}>
                  <SelectFilter onDateChange={onDateChangeHandler()} />
                </Col>

                <div className="col-2">
                  <div className="d-flex align-items-center">
                    <div
                      className="f10-400"
                      align="center"
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={handleClick}
                    >
                      <img
                         src={require("../../../assets/images/iconButton/sortbtn.svg")}
                         width="80px"
                         title="Sort"
                        alt="sorticon"
                      />
                    </div>
                    <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                    >
                      {userFilter.map((ele, index) => {
                        return (
                          <MenuItem
                            value={ele.title}
                            key={index}
                            onClick={() => setSort(ele.title)}
                            disabled={ele.disabled}
                          >
                            {ele.title}
                          </MenuItem>
                        );
                      })}
                    </Menu>
                    <div className="f10-400" align="center">
                      <img
                         src={require("../../../assets/images/iconButton/filterbtn.svg")}
                         width="80px"
                        alt="Filter Icon"
                        onClick={() => setShowFilter(!showFilter)}
                      />
                    </div>
                    <CSVDownloader
                      filename={"statement"}
                      headers={downloadData.headers}
                      data={downloadData.data}
                    />
                  </div>
                </div>
              </Row>
              <hr />

              {props.auth.loader ? (
                <AmealioLoader />
              ) : (<>
                <div className="mt-3 mb-3 p-2">
                  {state === 0 && <div className="d-flex justify-content-between">
                    <div className="f12-500">
                      <div>Amount <br />to be Paid</div>
                      <div className="mt-3">₹ {statement?.totalOrder?.toFixed(2) || 0}</div>
                    </div>
                    <div className="f12-500">
                      <div>Total <br />Tip Amount</div>
                      <div className="mt-3">₹ {statement?.totalTip?.toFixed(2) || 0}</div>
                    </div>
                    <div className="f12-500">
                      <div>Current <br />Settlement</div>
                      <div className="mt-3">₹ {statement?.totalOrder?.toFixed(2) || 0}</div>
                    </div>
                    <div className="f12-500">
                      <div>Credit <br />Memo</div>
                      <div className="mt-3">₹ {0}</div>
                    </div>
                    <div className="f12-500">
                      <div>Debit<br /> Memo</div>
                      <div className="mt-3">₹ {0}</div>
                    </div>
                    <div className="f12-500">
                      <div>Reversal<br /> Credit Memo</div>
                      <div className="mt-3">₹ {0}</div>
                    </div>
                    <div className="f12-500">
                      <div>Reversal<br /> Debit Memo</div>
                      <div className="mt-3">₹ {0}</div>
                    </div>
                    <div className="f12-500">
                      <div>Disputed<br /> Amount</div>
                      <div className="mt-3">₹ {0}</div>
                    </div>
                    <div className="f12-500">
                      <div>Payment<br /> Gateway</div>
                      <div className="mt-3">{NEFT}</div>
                    </div>
                    <div className="f12-500">
                      <div>Commission<br /> </div>
                      <div className="mt-3">₹ {totalComission(statement?.orders, statement?.comissionCode).toFixed(2)}</div>
                    </div>
                  </div>}
                  {[1, 2].includes(state) && <><Row>
                    <Col md={2}>
                      <div className="f12-500">Period</div>
                    </Col>
                    <Col md={2}>
                      <div className="f12-500">
                        Current Settlement Amount for{" "}
                        {state === 0
                          ? "Ordering"
                          : state === 1
                            ? "Event"
                            : "Scan And Pay"}
                      </div>
                    </Col>
                    {state === 1 && (
                      <Col md={2}>
                        <div className="f12-500">
                          Total Payable Amount{" "}
                          {state === 0
                            ? "Ordering"
                            : state === 1
                              ? "Event"
                              : "Scan And Pay"}
                        </div>
                      </Col>
                    )}
                    <Col md={2}>
                      <div className="f12-500">Payment Gateway</div>
                    </Col>
                    <Col md={2}>
                      <div className="f12-500">Commission</div>
                    </Col>
                  </Row>
                    <Row>
                      <Col md={2}>
                        <div className="f12-400">
                          {moment(statement?.startDate).format("DD-MM-YYYY")} -{" "}
                          {moment(statement?.endDate).format("DD-MM-YYYY")}
                        </div>
                      </Col>
                      {state === 0 ? (
                        <Col md={2}>
                          <div className="f12-400">
                            ₹{" "}
                            {statement?.totalTip?.toFixed(2)}{" "}
                          </div>
                        </Col>
                      ) : (
                        <> </>
                      )}
                      {/* <Col md={2}>
                        <div className="f12-400">₹ 0.00</div>
                      </Col> */}
                      <Col md={2}>
                        <div className="f12-400">
                          ₹{" "}
                          {state === 0 ? (
                            <>
                              {statement?.totalOrder?.toFixed(2)}{" "}
                            </>
                          ) : state === 1 ? (
                            <>
                              {statement?.totalEvent?.toFixed(2)}
                            </>
                          ) : (
                            <>
                              {" "}
                              {statement?.totalScan?.toFixed(2)}
                            </>
                          )}
                        </div>
                      </Col>

                      <Col md={2}>
                        <div className="f14-500">
                          <div className="f12-400">₹ {0.0}</div>
                        </div>
                      </Col>
                      <Col md={2}>
                        <div className="f12-400">₹ {0.0}</div>
                      </Col>
                    </Row>
                  </>
                  }

                  <hr />
                </div>
                <div>
                  <div className="f14-700 mt-3  mb-3">Payable orders</div>
                  <div className="d-flex justify-content-between">
                    <div className="w-50">
                      <div className="d-flex">
                        <div
                          className={`mr-5 ml-3 ${state === 0 && `selected-global-catalogue `
                            } f12-500`}
                          onClick={() => setState(0)}
                          style={{ cursor: "pointer" }}
                        >
                          Orders
                        </div>
                        <div
                          className={`mr-5 ml-3 ${state === 1 && `selected-global-catalogue `
                            } f12-500`}
                          onClick={() => setState(1)}
                          style={{ cursor: "pointer" }}
                        >
                          Events
                        </div>
                        <div
                          className={`mr-5 ml-3 ${state === 2 && `selected-global-catalogue `
                            } f12-500`}
                          onClick={() => setState(2)}
                          style={{ cursor: "pointer" }}
                        >
                          Scan & Pay
                        </div>
                      </div>
                      <hr />
                    </div>
                    <div>
                      <RightMenuStatus onTypeChange={onTypeChange} type={type} />
                      <hr />
                    </div>
                  </div>
                </div>
                <div>
                  <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                    <Table>
                      <thead>
                        <TableHead
                          display={
                            state === 0 ? (
                              <tr>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Order Type/ <br />
                                  Order ID
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Subtotal <br /> Of Items
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Discount
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Net Order <br /> Value
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Taxes
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Surcharges
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Tip
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Amount <br />Paid
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Outgoing <br /> Charges + GST
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Commission <br />+ GST
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Amount to<br /> be Settled
                                </th>
                              </tr>
                            ) : null
                          }
                          displayevents={
                            state === 1 ? (
                              <tr>
                                <th
                                  style={{ width: "17%" }}
                                  className="f12-500"
                                >
                                  Payment Method/ <br />
                                  Transaction ID
                                </th>
                                <th
                                  style={{ width: "14%" }}
                                  className="f12-500"
                                >
                                  Event/ Event ID/
                                  <br />
                                  Event Type
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500 ml-2"
                                >
                                  User
                                </th>
                                <th
                                  style={{ width: "10%" }}
                                  className="f12-500"
                                >
                                  Gross <br /> Amount
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Total PAX/ <br />
                                  Ticket No.
                                </th>
                                <th
                                  style={{ width: "10%" }}
                                  className="f12-500"
                                >
                                  Donation
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Ticket Total <br />
                                  Amount
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Payment Status
                                  <br />
                                  /Date & Time
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                ></th>
                              </tr>
                            ) : null
                          }
                          displayscanpay={
                            state === 2 ? (
                              <tr>
                                <th
                                  style={{ width: "15%" }}
                                  className="f12-500"
                                >
                                  Payment Method/ <br />
                                  Transaction ID
                                </th>
                                <th
                                  style={{ width: "15%" }}
                                  className="f12-500"
                                >
                                  User
                                </th>
                                <th
                                  style={{ width: "15%" }}
                                  className="f12-500"
                                >
                                  Total
                                  <br />
                                  Amount
                                </th>
                                <th
                                  style={{ width: "10%" }}
                                  className="f12-500"
                                >
                                  Tip
                                </th>
                                <th
                                  style={{ width: "10%" }}
                                  className="f12-500"
                                >
                                  Donation
                                </th>

                                <th
                                  style={{ width: "15%" }}
                                  className="f12-500"
                                >
                                  Payment Status
                                  <br />
                                  /Date & Time
                                </th>
                                <th
                                  style={{ width: "15%" }}
                                  className="f12-500"
                                ></th>
                              </tr>
                            ) : null
                          }
                        />
                      </thead>
                      {(state === 0 && filteredData) &&
                        filteredData?.orders?.map((order, index) => (
                          <TableBody
                            orderData={order}
                            comissionCode={statement?.comissionCode}
                            key={index}
                            loader={props.auth.loader}
                          />
                        ))}
                      {(state === 1 && filteredData?.event_requests) &&
                        filteredData?.event_requests.map((eventData, index) => (
                          <TableBodyEvents
                            eventData={eventData}
                            key={index}
                            loader={props.auth.loader}
                          />
                        ))}
                      {(state === 2 && filteredData?.scan_and_pay) &&
                        filteredData?.scan_and_pay.map((scanData, index) => (
                          <TableBodyScanAndPay
                            scanData={scanData}
                            key={index}
                            loader={props.auth.loader}
                          />
                        ))}
                    </Table>
                  </div>
                </div>
              </>)}
            </Container>
          </div>
        </div>
      </div>
    </React.Fragment >
  )
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  data: state.superadminManageTransactions.single_vendor_statement,
  vendorAccess: state.vendorAccess
});

export default connect(mapStateToProps, {
  get_merchant_statement
})(MerchantStatement);

const TableHead = (props) => {
  return (
    <>
      {props?.display}
      {props?.displayevents}
      {props?.displayscanpay}
    </>
  );
};

const TableBody = (props) => {
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });

  const calcTaxes = (data) => {
    let tax = 0;
    if (!isEmpty(data)) {
      tax = Object.values(data).reduce(
        (a, b) => parseFloat(a) + parseFloat(b),
        0
      );
    }
    return tax.toFixed(2);
  };


  const calcTotalPayAmount = (transactionDetails) => {
    let payAmount = 0;
    transactionDetails.forEach((ele) => {
      if (ele.paid && ele.method === 'RAZORPAY' && ele.type === 'PAYMENT') {
        payAmount += ele.amount;
      }
    })
    return payAmount;
  }

  const amountToSettle = (data) => {
    let orderPayAmount = 0;
    let gatewayCharges = (data?.gatewayCharges?.fee || 0) + (data?.gatewayCharges?.tax || 0);
    let donation = data.donation && data.donation.amount ? data.donation.amount : 0;
    let payAmount = data.settleAmount ? data.settleAmount : data.total_amount;
    let comission = orderComission(data, props?.comissionCode)
    if (payAmount) {
      orderPayAmount += payAmount - donation - gatewayCharges - comission;
      return orderPayAmount;
    }
    else {
      return orderPayAmount;
    }
  }

  const orderComission = (order, comissionCode) => {
    let comission = parseFloat(comissionCode?.description || 0);
    let value = ((order?.base_amount - (order?.offerSettlement === 'ADMIN' ? 0 : order?.discount?.amount || 0)) * comission) / 100;
    let gst = (value * 18) / 100
    return value + gst;
  }

  const orderComssionDetails = (order, comissionCode) => {
    let comission = parseFloat(comissionCode?.description || 0);
    let value = (((order?.base_amount - (order?.offerSettlement === 'ADMIN' ? 0 : order?.discount?.amount || 0)) * comission) / 100).toFixed(2);
    let gst = ((value * 18) / 100).toFixed(2)
    return { fee: value, gst: gst }
  }

  // const calcRazorpayCharges = (data) => {
  //   let transDetails = data.transactionDetails;
  //   let razorpayAmount = 0;
  //   transDetails.forEach((ele) => {
  //     if (ele.paid && ele.method === "RAZORPAY" && ele.type === "PAYMENT") {
  //       razorpayAmount += ele.amount;
  //     }
  //   });
  //   if (data.donation?.amount && razorpayAmount) {
  //     razorpayAmount = razorpayAmount - data.donation?.amount;
  //   }
  //   razorpayAmount = (razorpayAmount * 2) / 100;
  //   let tax = (razorpayAmount * 18) / 100;

  //   return (razorpayAmount + tax).toFixed(2);
  // };
  // console.log('Order');
  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", backgroundColor: "#ffffff" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr
                className={` cursor enGrayBorderBox sd_body_tr`}
                style={{
                  borderLeftWidth: "4px",
                  borderLeftStyle: "solid",
                  borderLeftColor: `${props.orderData?.blockSettlement ? "#EE3A23" : "#06A200"
                    }`,
                }}
                onClick={showTr}
              >
                <td style={{ width: "12%" }}>
                  <div className="f12-500 text-break pl-3">
                    {props.orderData && props.orderData.order_type === 0
                      ? "Take Away"
                      : props.orderData && props.orderData.order_type === 1
                        ? "Curb Side"
                        : props.orderData && props.orderData.order_type === 3
                          ? "Dine-In"
                          : "Skip The Line"}
                    <br />
                    {props && props.orderData && props.orderData.order_id}
                  </div>
                </td>
                <td style={{ width: "12%" }}>

                  <div className="f12-500">
                    ₹ {props?.orderData?.base_amount?.toFixed(2) || 0}
                  </div>

                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    - ₹ {props?.orderData?.discount?.amount.toFixed(2) || 0}
                  </div>
                </td>

                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {((props?.orderData?.base_amount || 0) - (props?.orderData?.discount?.amount || 0)).toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 d-flex">
                      ₹{calcTaxes(props.orderData.gstAmount)}
                    </div>
                    <InfoToolTip title={"View the bifurcation of Taxes"} data={props.orderData.gstAmount} />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">
                      ₹ {calcTaxes(props.orderData.surCharges)}
                    </div>
                    <InfoToolTip title={"View the bifurcation of Surcharges"} data={props.orderData.surCharges} />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.orderData?.tip?.amount || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.orderData?.total_amount?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">
                      ₹{" "}
                      {(parseFloat(props?.orderData?.outgoingCharges?.fee || 0) + parseFloat(props?.orderData?.outgoingCharges?.tax || 0)).toFixed(2)}
                    </div>
                    <InfoToolTip title={"Outgoing gateway charges + GST"} data={props.orderData.outgoingCharges} />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">
                      ₹ {orderComission(props.orderData, props?.comissionCode).toFixed(2)}
                    </div>
                    <InfoToolTip title={"Comission Charges + 18% GST"} data={orderComssionDetails(props.orderData, props?.comissionCode)} />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {amountToSettle(props.orderData).toFixed(2)}
                  </div>
                </td>
              </tr>
              {TrDetail.TrDetail && (
                <>
                  <tr
                    className="sd_accordion_body"
                    style={{ background: "#ffffff" }}
                  >
                    <div className="container-fluid">
                      <div className="row d-flex justify-content-between">
                        <div className="f12-500">
                          <div>Dispute Id</div>
                          <div className="mt-3">N/A</div>
                        </div>
                        <div className="f12-500">
                          Disputed Amount
                          <div className="mt-3">₹ 0</div>
                        </div>
                        <div className="f12-500">Disputed Items
                          <div className="mt-3">N/A</div>
                        </div>
                        <div className="f12-500">Disputed Status
                          <div className="mt-3">N/A</div>
                        </div>
                        <div className="f12-500">
                          Due Date
                          <div className="mt-3">
                            {moment(props.orderData?.settleAfter).add(1, 'day').format("MM-DD-YYYY")}
                            <br />
                            {moment(props.orderData?.settleAfter).add(1, 'day').format("LT")}
                          </div>
                        </div>
                        <div className="f12-500">
                          No of Items
                          <div className="mt-3">{props?.orderData?.order_items?.length}</div>
                        </div>
                        <div className="f12-500">
                          Offer Type
                          <div className="mt-3">
                            {props?.orderData?.offerSettlement === 'ADMIN' ? 'Amealio Offer' : props?.orderData?.discount?.amount ? "Merchant Offer" : 'N/A'}
                          </div>
                        </div>
                        <div className="f12-500">
                          Order Date
                          <div className="mt-3"> {moment(props.orderData?.createdAt).format("MM-DD-YYYY")}
                            <br />
                            {moment(props.orderData?.createdAt).format("LT")}</div>
                        </div>
                        <div className="f12-500">
                          Payment Block
                          <div className="mt-3">{props?.orderData?.blockReason || "-"}</div>
                        </div>
                        <div className="f10-400 m-2" align="center">
                          <img
                            src={require("../../../assets/images/iconButton/eye.png")}
                            width="35px"
                            alt="icon"
                          />
                          <br />
                          View <br /> Dispute
                        </div>
                        <div className="f10-400 m-2" align="center">
                          <img
                            src={require("../../../assets/images/iconButton/eye.png")}
                            width="35px"
                            alt="icon"
                          />
                          <br />
                          View <br /> Transaction
                        </div>
                      </div>
                    </div>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

const TableBodyEvents = (props) => {
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", backgroundColor: "#ffffff" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr
                style={{
                  borderLeftWidth: "4px",
                  borderLeftStyle: "solid",
                  borderLeftColor: `${props.eventData?.blockSettlement ? "#EE3A23" : "#06A200"
                    }`,
                }}
                onClick={showTr}
              >
                {/* // TODO Need to Maintain ENUM */}
                <td style={{ width: "14%" }}>
                  <div className="f12-500 text-break">
                    {props.eventData &&
                      props.eventData?.payment_data?.payment_method === 0
                      ? "COD"
                      : props.eventData?.payment_data?.payment_method === 1
                        ? "UPI"
                        : props.eventData?.payment_data?.payment_method === 2
                          ? "Paytm"
                          : props.eventData?.payment_data?.payment_method === 3
                            ? "Debit Card"
                            : props.eventData?.payment_data?.payment_method === 4
                              ? "Credit Card"
                              : props.eventData?.payment_data?.payment_method === 5
                                ? "NetBanking"
                                : props.eventData?.payment_data?.payment_method === 6
                                  ? "Pay Later"
                                  : props.eventData?.payment_data?.payment_method === 7
                                    ? "Wallet"
                                    : props.eventData?.payment_data?.payment_method === 8
                                      ? "External Wallet"
                                      : props.eventData?.payment_data?.payment_method === 9
                                        ? "Cash"
                                        : null}
                    <br />
                    {props?.eventData?.transactional_id || "-"}
                  </div>
                </td>
                <td style={{ width: "14%" }}>
                  <div className="d-flex align-items-center ml-4">
                    <div className="f12-500 text-break">
                      {props?.eventData?.event?.name}
                      <br />
                      {props?.eventData?.event?.event_id}
                      <br />
                      {props?.eventData?.event_type === "TICKET_BOOKED"
                        ? "Ticket Booking"
                        : "RSVP"}
                    </div>
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 ml-4">
                      {props?.eventData?.user_details?.name}
                    </div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="d-flex align-items-center ml-4">
                    <div className="f12-500 ml-3">
                      {props?.eventData?.payment_data?.total_amount || 0}
                    </div>
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500 ml-4" style={{ paddingLeft: "10%" }}>
                    {props?.eventData?.adult_count +
                      props?.eventData?.kids_count}
                    <br />
                    {props?.eventData?.event_request_id}
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="d-flex align-items-center ml-4">
                    <div className="f12-500 ml-3">
                      {props?.eventData?.payment_data?.donate_amount || 0}
                    </div>
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500 ml-4">
                    ₹ {props?.eventData?.payment_data?.total_amount || 0}
                  </div>
                </td>
                <td style={{ width: "12%", paddingLeft: "3%" }}>
                  <div className="badge badge-success">Success</div>
                  <br />
                  {moment(props?.eventData?.createdAt).format("MM-DD-YYYY")}
                  <br /> {moment(props?.eventData?.createdAt).format("LT")}
                </td>
              </tr>
              {TrDetail.TrDetail && (
                <tr
                  className="sd_accordion_body"
                  style={{ background: "#ffffff" }}
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-2 f12-500">Service Charge</div>
                      <div className="col-1 f12-500">GST</div>
                      <div className="col-1 f12-500">CC Charges</div>
                      <div className="col-2 f12-500">Attended Date</div>
                      <div className="col-1 f12-500">Razorpay Fee</div>
                      <div className="col-2 f12-500">Razorpay tax</div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-2 f12-500">
                        ₹ {props?.eventData?.payment_data?.service_Charge}
                      </div>
                      <div className="col-1 f12-500">
                        ₹ {props?.eventData?.payment_data?.tax_charge}
                      </div>
                      <div className="col-1 f12-500">-</div>
                      <div className="col-2 f12-500">N/A</div>
                      <div className="col-1 f12-500">₹ -</div>
                      <div className="col-2 f12-500">₹ -</div>
                    </div>
                  </div>
                </tr>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

const TableBodyScanAndPay = (props) => {
  return (
    <React.Fragment>
      <tbody>
        <tr
          className="super_admin_all_users_table_body"
          style={{
            borderLeftWidth: "4px",
            borderLeftStyle: "solid",
            borderLeftColor: `${props.scanData?.blockSettlement ? "#EE3A23" : "#06A200"
              }`,
          }}
        >
          <td className="text-break" style={{ width: "15%" }}>
            <div className="f12-500">
              {props && props.scanData && props.scanData.transaction_type}
              <br />
              {props && props.scanData && props.scanData._id}
            </div>
          </td>
          <td style={{ width: "15%" }}>
            <div className="d-flex align-items-center">
              <Image src={""} width="20px" fluid />
              <div className="f12-500 text-break">
                {props.scanData && props.scanData.user_id}
                {/* zomaland
                <br />
                1245789632
                <br />
                Ticket booked */}
              </div>
            </div>
          </td>
          <td style={{ width: "15%" }}>
            <div className="f15-500">
              ₹ {props.scanData && props.scanData.amount}
            </div>
          </td>
          <td style={{ width: "10%" }}>
            <div className="f15-500">₹ {props?.scanData.tip || 0}</div>
          </td>
          <td style={{ width: "10%" }}>
            <div className="f15-500">₹ {props?.scanData.donation || 0}</div>
          </td>
          <td style={{ width: "15%" }}>
            <div className="badge badge-success">Success</div>
            <div className="f12-500">
              {moment(props.scanData && props.scanData.createdAt).format(
                "MM-DD-YYYY"
              )}
              <br />{" "}
              {moment(props.scanData && props.scanData.createdAt).format("LT")}
            </div>
          </td>
        </tr>
      </tbody>
    </React.Fragment>
  );
};



const StatusRightMenuArr = [
  { title: "All", value: 0 },
  { title: "Cleared", value: 1 },
  { title: "Open", value: 2 },
  { title: "Disputed", value: 3 },
  { title: "Blocked", value: 4 },
];

const RightMenuStatus = (props) => {
  return (
    <div className="d-flex">
      {StatusRightMenuArr.map((e) => (
        <div
          className={`mr-5 ml-3 ${props.type === e.value && `selected-global-catalogue `
            } f12-500`}
          onClick={() => props.onTypeChange(e.value)}
          style={{ cursor: "pointer" }}
          key={e.title}
        >
          {e.title}
        </div>
      ))}
    </div>
  );
};
